// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2fy-1","error":"Textarea_error__2NaB7","readonly":"Textarea_readonly__1Uu7M","disabled":"Textarea_disabled__1nWUy"};